import { useCurrentDeveloperContext } from "@services/useDeveloper/CurrentDeveloperContext";

/**
 * Retrieve the current developer's information.
 *
 * This is guaranteed to be available immediately, because the placeholder data is the current developer as
 * populated in Braze's dashboard config.
 *
 * As endpoints are added that update the developer, they can invalidate the cache, guaranteeing the developer is
 * only ever a few seconds out of date.
 *
 * In addition, this is pushed out to the meta-view model to keep legacy knockout views in sync
 */
export const useDeveloper = () => useCurrentDeveloperContext();
